// Shared layout constants for portfolio position tables + virtual scroll.
export const POSITION_ROW_HEIGHT = 26;
export const POSITION_TABLE_HEADER_HEIGHT = 42;
export const POSITION_TABLE_VIEWPORT_OFFSET = 250;
export const POSITION_VIRTUAL_BUFFER = 10;

export const getPositionTableBodyHeight = (measuredContainerHeight = 0) => {
  const estimated =
    typeof window !== "undefined"
      ? window.innerHeight -
        POSITION_TABLE_VIEWPORT_OFFSET -
        POSITION_TABLE_HEADER_HEIGHT
      : 500;

  const measured =
    measuredContainerHeight > 0
      ? measuredContainerHeight - POSITION_TABLE_HEADER_HEIGHT
      : 0;

  return Math.max(measured, estimated);
};
